export default __webpack_public_path__ + "2c152df6991a423152f8dacfe1231e6c.png";